import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  patient: {
    id: 'components.DialogVideoOnDemandSessionCreation.SessionLinkStep.patient',
    defaultMessage: 'Patient link',
  },
  provider: {
    id: 'components.DialogVideoOnDemandSessionCreation.SessionLinkStep.provider',
    defaultMessage: 'Provider link',
  },
  guest: {
    id: 'components.DialogVideoOnDemandSessionCreation.SessionLinkStep.guest',
    defaultMessage: 'Guest link',
  },
  zoom: {
    id: 'components.DialogVideoOnDemandSessionCreation.SessionLinkStep.zoom',
    defaultMessage: 'Zoom link',
  },
});
